import { Snowfall } from 'react-snowfall';
import { useIsHolidaySeason } from '../../hooks/useIsHolidaySeason';

export const SnowfallEffect = () => {
  const isHolidaySeason = useIsHolidaySeason();

  if (!isHolidaySeason) {
    return null;
  }

  return (
    <Snowfall
      snowflakeCount={200}
      speed={[0.5, 3]}
      wind={[-0.5, 2]}
      radius={[0.5, 3]}
      color="#ffffff"
      style={{
        position: 'fixed',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        zIndex: 9999,
        pointerEvents: 'none',
      }}
    />
  );
};

